import PropTypes from 'prop-types';
import React, {Component} from 'react';

import CartPropertySelection from './CartPropertySelection'

class CartPropertyDropdownSelection extends Component {

    static propTypes = {
        ...CartPropertySelection.propTypes,
        placeHolder: PropTypes.string,
        hideDefaultInclusiveTag: PropTypes.bool,
        selectionSuffix: PropTypes.string,
        inclusiveLabel: PropTypes.string
    }

    static defaultProps = {
        placeHolder: "",
        inclusiveLabel: " (inklusive)"
    }

    constructor(props) {

        super(props)

        this.state = {
            isOpened: false,
            focusedIndex: 0, // Track the focused button index
        }

        this.optionRefs = []; // Store refs for buttons
        this.areaRef = React.createRef();
        this.triggerRef = React.createRef();

    }

    componentWillUnmount() {

        window.removeEventListener('click', this.handleDocumentClick)

    }

    handleDocumentClick = (e) => {

        const area = this.areaRef.current;

        if (!area.contains(e.target)) {
            this.setState({
                isOpened: false
            })
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if (this.state.isOpened) {
            window.addEventListener('click', this.handleDocumentClick)
        } else {
            window.removeEventListener('click', this.handleDocumentClick)
        }

    }

    handleOptionSelect = (clickedOption, defaultOption, selectedProperty, handleOptionSelect) => {

        handleOptionSelect(clickedOption)

        this.triggerRef.current.focus();

        this.setState({
            isOpened: false,
            focusedIndex: 0
        })

    }

    handleTriggerClick = (e) => {

        this.setState({
            isOpened: !this.state.isOpened
        })

    }

    renderOptions = (handleOptionSelect, handleOptionDeSelect, defaultOption, selectedProperty) => {
        this.optionRefs = []; // Reset refs

        const propertyOptionsListing = this.props.propertyOptions.map((propertyOption) => {

            const isDisabled = propertyOption.disabled

            return (
                <button
                    type="button"
                    key={propertyOption.value}
                    ref={(el) => {
                        if (!isDisabled && el != null) this.optionRefs.push(el);
                    }} // Store non-disabled refs
                    onClick={(e) => {
                        if (isDisabled) {
                            return
                        }
                        this.handleOptionSelect(propertyOption.value, defaultOption, selectedProperty, handleOptionSelect)
                    }}
                    className={'article-simple-dropdown__options__option' + (propertyOption.value === selectedProperty ? " article-simple-dropdown__options__option--selected" : '') + (isDisabled ? ' article-simple-dropdown__options__option--disabled' : '')}
                >
                    {propertyOption.display.icon ? <img role="presentation" src={propertyOption.display.icon}/> : null}
                    {propertyOption.display.title}
                </button>
            )
        })


        return (
            <div className="article-simple-dropdown__options">
                {propertyOptionsListing}
            </div>
        )

    }

    handleKeyDown = (event) => {

        const {propertyOptions} = this.props;
        let {focusedIndex} = this.state;

        // Filter out disabled options
        const focusableOptions = propertyOptions.filter(option => !option.disabled);
        const totalOptions = focusableOptions.length;
        if (totalOptions === 0) return;


        if (event.key === "ArrowDown") {
            event.preventDefault();
            if (this.state.isOpened) {
                focusedIndex = (focusedIndex + 1) % totalOptions;
            } else {
                this.setState({isOpened: true});
                focusedIndex = 0;
            }
        } else if (this.state.isOpened && event.key === "ArrowUp") {
            event.preventDefault();
            focusedIndex = (focusedIndex - 1 + totalOptions) % totalOptions;
        } else if (this.state.isOpened && event.key === "Escape") {
            this.setState({isOpened: false});
            this.triggerRef.current.focus();
            focusedIndex = 0;
        }

        this.setState({focusedIndex}, () => {
            if (this.optionRefs[focusedIndex]) {
                this.optionRefs[focusedIndex].focus();
            }
        });
    };

    renderDropdown(handleOptionSelect, handleOptionDeSelect, defaultOption, selectedProperty) {


        const hasCustomSelection = (selectedProperty && selectedProperty !== defaultOption)
        const isDefaultSelected = defaultOption && selectedProperty === defaultOption


        const selectedPropertyOption = this.props.propertyOptions.find(propertyOption => propertyOption.value === selectedProperty)

        return (
            <div ref={this.areaRef}
                 className={"article-simple-dropdown" + (this.state.isOpened ? ' article-simple-dropdown--opened' : '')}
                 onKeyDown={this.handleKeyDown}
            >
                {hasCustomSelection ?
                    <button type="button" onClick={handleOptionDeSelect} className="article-simple-dropdown__clear">x</button> : null}
                <button type="button" ref={this.triggerRef} onClick={this.handleTriggerClick}
                        className={"article-simple-dropdown__trigger" + (hasCustomSelection ? ' article-simple-dropdown__trigger--selected' : '') + (isDefaultSelected ? ' article-simple-dropdown__trigger--default' : '')}>
                    {(selectedProperty && selectedPropertyOption.display.icon) ?
                        <img role="presentation" src={selectedPropertyOption.display.icon}/> : null}
                    {selectedProperty ?
                        <span>
							{selectedPropertyOption.display.title}
                            {(isDefaultSelected && !this.props.hideDefaultInclusiveTag) ? this.props.inclusiveLabel : null}
                            {((isDefaultSelected || hasCustomSelection) && this.props.selectionSuffix) ? this.props.selectionSuffix : null}
						</span> : (this.props.placeHolder ? this.props.placeHolder : null)
                    }
                </button>
                {this.state.isOpened ? this.renderOptions(handleOptionSelect, handleOptionDeSelect, defaultOption, selectedProperty) : null}
            </div>
        )

    }

    render() {
        return (
            <CartPropertySelection
                propertyOptions={this.props.propertyOptions}
                activeCartProperty={this.props.activeCartProperty}
                selectPropertyCallback={this.props.selectPropertyCallback}
            >
                {(handleOptionSelect, handleOptionDeSelect, defaultOption, selectedProperty) => {
                    return (
                        this.renderDropdown(handleOptionSelect, handleOptionDeSelect, defaultOption, selectedProperty)
                    )
                }}
            </CartPropertySelection>
        )

    }

}

export default CartPropertyDropdownSelection



/** WEBPACK FOOTER **
 ** ./src/containers/configuration/CartPropertyDropdownSelection.js
 **/